import React, { createContext, useContext, useState, useEffect } from 'react';

interface DeviceCountState {
  tgmaxxCount: number | null;
  setTgmaxxCount: (count: number) => void;
}

const DeviceCountContext = createContext<DeviceCountState | undefined>(undefined);

export function DeviceCountProvider({ children }: { children: React.ReactNode }) {
  const [tgmaxxCount, setTgmaxxCountState] = useState<number | null>(null);

  const setTgmaxxCount = (count: number) => {
    setTgmaxxCountState(count);
    // Store in localStorage for persistence across sessions
    localStorage.setItem('tgmaxx-device-count', count.toString());
  };

  // Load from localStorage on mount
  useEffect(() => {
    const stored = localStorage.getItem('tgmaxx-device-count');
    if (stored) {
      setTgmaxxCountState(parseInt(stored, 10));
    }
  }, []);

  return (
    <DeviceCountContext.Provider value={{ tgmaxxCount, setTgmaxxCount }}>
      {children}
    </DeviceCountContext.Provider>
  );
}

export function useDeviceCount() {
  const context = useContext(DeviceCountContext);
  if (context === undefined) {
    throw new Error('useDeviceCount must be used within a DeviceCountProvider');
  }
  return context;
}